import React, { isValidElement } from 'react';
import Button from '../Button/Button.es.js';
import { IconButton } from '../IconButton/IconButton.es.js';
import { Text } from '../Text/Text.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputGroupAddon = ({ children }) => /* @__PURE__ */ React.createElement(React.Fragment, null, children);
const addonSpacingProps = (placement) => placement === "left" ? { ml: "sm" } : { mr: "sm" };
const InputGroupIcon = (_a) => {
  var _b = _a, { placement, children } = _b, props = __objRest(_b, ["placement", "children"]);
  const spacingProps = addonSpacingProps(placement);
  if (!isValidElement(children)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  }
  return React.cloneElement(children, __spreadValues(__spreadValues(__spreadValues({}, spacingProps), props), children.props));
};
InputGroupIcon.displayName = "InputGroup.Addon";
const InputGroupButton = forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Button, __spreadValues({
  ref
}, props)));
InputGroupButton.displayName = "InputGroup.Addon";
const InputGroupIconButton = forwardRef((props, ref) => /* @__PURE__ */ React.createElement(IconButton, __spreadValues({
  ref
}, props)));
InputGroupIconButton.displayName = "InputGroup.Addon";
const InputGroupText = (_c) => {
  var _d = _c, { placement } = _d, props = __objRest(_d, ["placement"]);
  const spacingProps = addonSpacingProps(placement);
  return /* @__PURE__ */ React.createElement(Text, __spreadValues(__spreadValues({}, spacingProps), props));
};
InputGroupText.displayName = "InputGroup.Addon";

export { InputGroupAddon, InputGroupButton, InputGroupIcon, InputGroupIconButton, InputGroupText };
//# sourceMappingURL=InputGroupAddon.es.js.map
